import React from "react";
import {
  Wrench,
  Target,
  Gauge,
  Wind,
  Shield,
  Disc,
  Lightbulb,
  Focus,
} from "lucide-react";
import { SERVICES } from "../lib/constants";

const ICONS = { Wrench, Target, Gauge, Wind, Shield, Disc, Lightbulb, Focus };

const SERVICES_BG =
  "https://static.prod-images.emergentagent.com/jobs/55965fb7-f09c-47b4-bb31-d6b610b36aa9/images/528b2eb046a2c875c3e9eec1b44b1ff88cf50825d14b12ef881771f2efd68cab.png";

export const Services = () => {
  return (
    <section
      data-testid="services-section"
      id="servicos"
      className="relative pt-28 pb-14 md:pt-32 md:pb-16 overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-25"
        style={{ backgroundImage: `url(${SERVICES_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-[#0E2452]/95 via-[#0E2452]/85 to-[#FF5A00]/20" />

      <div className="relative z-10 w-full px-6 md:px-12 lg:px-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-5">
          <div className="max-w-2xl">
            <span data-testid="services-label" className="section-label">
              // O que fazemos
            </span>
            <h2
              data-testid="services-title"
              className="heading-lg text-white mt-3"
            >
              Serviços <span className="text-[#FF5A00]">completos</span> para o seu carro
            </h2>
          </div>
          <p className="max-w-md text-[#A1A1AA] text-sm font-body">
            Da troca simples à configuração desportiva completa. Diagnosticamos,
            reparamos e entregamos no mesmo dia, sem compromissos de qualidade.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {SERVICES.map((s, idx) => {
            const Icon = ICONS[s.icon] || Wrench;
            const isAccent = idx === 1;
            return (
              <article
                key={s.key}
                data-testid={`service-card-${s.key}`}
                className={`group relative p-5 rounded-2xl border transition-all duration-300 hover:-translate-y-0.5 ${
                  isAccent
                    ? "bg-[#FF5A00] border-[#FF5A00] text-black"
                    : "bg-[#163A6D] border-[#2F568F] hover:border-[#FF5A00]"
                }`}
              >
                <div className="flex items-start justify-between mb-4">
                  <div
                    className={`w-11 h-11 rounded-xl flex items-center justify-center border ${
                      isAccent
                        ? "border-black/30 bg-black/10"
                        : "border-[#2F568F] bg-[#0E2452] group-hover:border-[#FF5A00] group-hover:text-[#FF5A00]"
                    } transition-colors`}
                  >
                    <Icon
                      className={`w-5 h-5 ${
                        isAccent ? "text-black" : "text-white"
                      }`}
                      strokeWidth={1.5}
                    />
                  </div>
                </div>

                <h3
                  className={`font-display font-semibold text-base uppercase mb-1.5 leading-tight ${
                    isAccent ? "text-black" : "text-white"
                  }`}
                >
                  {s.title}
                </h3>
                <p
                  className={`text-xs leading-relaxed font-body ${
                    isAccent ? "text-black/80" : "text-[#A1A1AA]"
                  }`}
                >
                  {s.desc}
                </p>
                {s.free && (
                  <div
                    data-testid={`service-free-badge-${s.key}`}
                    className={`mt-3 inline-flex items-center gap-2 px-2.5 py-1 rounded-full border font-display font-bold uppercase tracking-[0.2em] text-[10px] ${
                      isAccent
                        ? "border-black/40 bg-black/10 text-black"
                        : "border-[#FF5A00] bg-[#FF5A00]/10 text-[#FF5A00]"
                    }`}
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-[#FF5A00] animate-pulse" />
                    Serviço gratuito
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
